import { getPriceButtonText } from '../../../utils/priceText';
import { definitionFactory } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';

export const priceInputDefinition = definitionFactory({
  key: 'price',
  mapper: ({ gte, lte }, _tags, appState) => {
    const isPerSquareMeter = appState.jsonQuery.price_sm?.value === true;

    return gte || lte
      ? [
          {
            label: getPriceButtonText(gte, lte, isPerSquareMeter),
            value: { gte, lte },
          },
        ]
      : [];
  },
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'price', options);
  },
});
